export default __webpack_public_path__ + "static/media/ISKO_CLASS-7_SYLLABUS.7b4da91c.pdf";